import RsaAccettazione from "../";

const routes = [
  {
    name: "RsaAccettazioneListPage",
    path: "/rsaaccettazione",
    component: RsaAccettazione.RsaAccettazioneListPage,
    meta: { title: "R.S.A. - Accettazione" },
  },
  {
    name: "RsaAccettazioneEdit",
    path: "/rsaaccettazione/edit/:id",
    component: RsaAccettazione.RsaAccettazioneEdit,
    meta: { title: "R.S.A. - Accettazione" },
  },
  {
    name: "RsaAccettazioneViewPage",
    path: "/rsaaccettazione/view/:id",
    component: RsaAccettazione.RsaAccettazioneViewPage,
    meta: { title: "R.S.A. - Accettazione" },
  },
  { name: "RsaAccettazioneRicetteEdit", path: "/rsaaccettazione/ricette/edit/:id", component: RsaAccettazione.RsaAccettazioneRicetteEditPage, meta: { title: "R.S.A. - Accettazione Ricette" } },
];

export default routes;
